module.exports = __webpack_public_path__ + "static/img/news_05.f3fec11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_05.jpg
// module id = 52Av
// module chunks = 2